import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ section }: PresentationIsEmptyProps) {
  const cards = section?.fields?.cards

  if (cards.length === 0) return true
}
